import { Clip } from '@goldcast/player-config/src/types/clip-types';
import { getClipScenes, getIsDuplicateRecording, isClipInvalid } from '@goldcast/player-config/src/utils/clipUtils';
import { core } from '@/stores/core';

export function getAnalyticsClipEditType(entityUpdated: string): string {
  switch (entityUpdated) {
    case 'DELETE_WORDS':
    case 'EDIT_WORD':
    case 'CAPTIONS_ON':
    case 'CAPTIONS_OFF':
    case 'UPDATE_HIGHLIGHT_TYPE':
    case 'UPDATE_HIGHLIGHT_COLOR':
      return 'Captions';
    case 'TOGGLE_SPEAKER_LABELS':
    case 'UPDATE_VISIBLE_FACE_IDS':
    case 'UPDATE_VISIBLE_SPEAKERS':
      return 'Speakers';
    case 'SELECT_MAGIC_LAYOUT':
    case 'CHANGE_SIZE':
    case 'UPDATE_MAGIC_LAYOUT':
    case 'LAYOUT_CHANGE':
    case 'SELECT_FIT_MODE':
      return 'Layout';
    case 'DURATION_CHANGED':
      return 'Duration';
    case 'CAPTIONS_TRANSLATION':
    case 'LANGUAGE_CHANGE':
      return 'Translation';
    case 'IMAGE_OVERLAY':
      return 'ImageOverlay';
    case 'SPLIT':
      return 'Split';
    default:
      return entityUpdated;
  }
}

export function getVideoSource(clip: Clip): string {
  const mediaSourceType = clip.content?.media_source_type;
  const eventType = clip.content?.event_type;

  if (mediaSourceType === 'UPLOAD') {
    return 'Upload';
  }

  if (mediaSourceType === 'RECORDING') {
    if (eventType === 'Recording') {
      return 'Recording';
    }
    return 'Event';
  }

  return 'Event';
}

export function getClipAnalyticsPayload(clip: Clip) {
  const coreStore = core.getSnapshot();

  return {
    id: clip.id,
    projectId: clip.content?.project.id,
    contentId: clip.content?.id,
    savedSearchId: clip.saved_search?.id,
    title: clip.title,
    is_sample_upload: clip.content?.is_sample_upload,
    isCustomUpload: clip.content?.media_source_type === 'UPLOAD',
    generatedBy: clip.asset_metadata.source,
    contentType: 'CLIP',
    templateType: clip.asset_metadata.layout,
    size: clip.asset_metadata.size,
    captions: clip.asset_metadata.subtitle ? 'On' : 'Off',
    videoLanguage: coreStore.content?.video_language,
    isFullLength: !!clip.asset_metadata.is_full_length,
    isDuplicate: getIsDuplicateRecording(clip)
  };
}

export const getClipAnalyticsPayloadV2 = (clip: Clip) => {
  if (isClipInvalid(clip)) {
    return {};
  }
  return {
    ...getClipAnalyticsPayload(clip),
    content: clip.content,
    scenes: getClipScenes(clip)
  };
};
